export default __webpack_public_path__ + "static/media/img_step_car01.ad61715e.jpg";